// Alcohol Beverage Control (ABC) states — the 17 US states where the
// state government holds a monopoly on the wholesale or retail
// distribution of distilled spirits. Source: NABCA membership list.
//
// Why this matters for HY: the sales motion is structurally different
// in a control state vs a license state. In a control state the state
// liquor board is effectively the buyer — listings, listings reviews,
// and promotional approvals run through a single agency. In a license
// state the rep pitches distributors and individual retail outlets.
// Flagging the state up-front saves reps from re-deriving it.

export const CONTROL_STATES: ReadonlySet<string> = new Set<string>([
  'AL', // Alabama ABC Board
  'ID', // Idaho State Liquor Division
  'IA', // Iowa Alcoholic Beverages Division (wholesale)
  'ME', // Maine BABLO (wholesale)
  'MI', // Michigan Liquor Control Commission (wholesale)
  'MS', // Mississippi DOR Alcoholic Beverage Control (wholesale)
  'MT', // Montana DOR Liquor Control Division (wholesale)
  'NH', // New Hampshire Liquor Commission
  'NC', // NC ABC
  'OH', // Ohio Division of Liquor Control (wholesale)
  'OR', // Oregon Liquor & Cannabis Commission
  'PA', // Pennsylvania Liquor Control Board
  'UT', // Utah DABS
  'VT', // Vermont DLC (wholesale)
  'VA', // Virginia ABC
  'WV', // West Virginia ABCA (wholesale)
  'WY', // Wyoming Liquor Division (wholesale)
]);

export type StateClassification = 'control' | 'license';

/** Returns 'control' / 'license' for any 2-letter state code. NULL → 'license' fallback. */
export function classifyState(stateCode: string | null | undefined): StateClassification {
  if (!stateCode) return 'license';
  return CONTROL_STATES.has(stateCode.toUpperCase()) ? 'control' : 'license';
}

export function isControlState(stateCode: string | null | undefined): boolean {
  return classifyState(stateCode) === 'control';
}
